import Axios from "axios"
import React from "react";
import { Badge } from "react-bootstrap";
import { sortCaret } from "../../../_metronic/_helpers";
 
 // }
const url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/campaigns";
const geo = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/geo"

export function setPayment(uid, payment) {
  return Axios.put(`${url}/update/${uid}`, { payment });

}
export function getStates() {
  return Axios.get(`${geo}/`);

}
export const columns = [
  {
    dataField: "no",
    text: "#",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      width: "60px",
    },
  },
  {
    dataField: "name",
    text: "Campaign",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      maxWidth: "100px",
    },
  },
  {
    dataField: "states",
    text: "State(s)",
    Sort: true
  },
  {
    dataField: "locations",
    text: "# POS",
    Sort: true
  },
  {
    dataField: "pos_visited",
    text: "Visited",
    Sort: true
  },
  {
    dataField: "campaign_state",
    text: "Status",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      minWidth: "50px",
    },
    formatter: (cellContent, row, rowIndex) => {

      if (row.mode === "draft") {
        return (
          <Badge variant={"warning"}>Draft</Badge>
        )
      }

      const state = row.status
      const states = {
        "Waiting for start": "danger",
        "On Going": "warning",
        "Done": "success"
      }
      return (
        <Badge variant={states[state]}>{state}</Badge>
      )
    }

  },

  {
    dataField: "start_date",
    text: "Start Date",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      minWidth: "100px",
    },
  },
  {
    dataField: "end_date",
    text: "End Date",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      minWidth: "80px",
    },
  },
  // {
  //   dataField: "start",
  //   text: "Timeline",
  //   Sort: true,
  //   headerStyle: {
  //     minWidth: "80px",
  //   },
  //   formatter: (cellContent, row, rowIndex) => <Badge variant="info">{}-{row.end_time}</Badge>,
  // },
  // {
  //   dataField: "price",
  //   text: "Cost",
  //   sort: true,
  //   sortCaret: sortCaret,
  //   headerStyle: {
  //     minWidth: "80px",
  //   },
  //   formatter: (cellContent, row, rowIndex) => <Badge variant="success">${row.cost}</Badge>,
  // }
];

export function getClients(setCategory) {
  Axios.get(`${url}/find`,)
    .then((res) => {
      const categories = res.data.payload;
      setCategory(categories);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
        console.log(`request cancelled:${thrown.message}`)
      } else {
        console.log('another error happened')
      }
    })
}
export function getParents() {
  return Axios.get(`${url}/findParents`);

}
export function getParentsCallback(callback){
  Axios.get(`${url}/findParents`)
  .then((res) => {
    const data = res.data.payload;
    callback(data);
  })
  .catch(function (thrown) {
    if (Axios.isCancel(thrown)) {
      console.log(`request cancelled:${thrown.message}`)
    } else {
      console.log('another error happened')
    }
  })
}
export function getClient(uid) {
  return Axios.get(`${url}/find/${uid}`);
}
export function getChildrens(uid) {
  return Axios.get(`${url}/parent/${uid}`);
}
export function updateSoftClient(campaign) {
  if (campaign.uid) {
    return Axios.put(`${url}/softupdate/${campaign.uid}`, campaign);
  }
}
export function updateClient(campaign) {
  if (campaign.uid) {
    return Axios.put(`${url}/update/${campaign.uid}`, campaign);
  } else {
    return Axios.post(`${url}/create`, campaign);
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url}/delete/${uid}`);
}

export function getPreview(uid) {
  return Axios.get(`${url}/preview/${uid}`);

}
export function getReport(uid) {
  return Axios.get(`${url}/report/${uid}`);

}


